import { render, staticRenderFns } from "./TabTemperature.vue?vue&type=template&id=6111b8d1&scoped=true&"
import script from "./TabTemperature.vue?vue&type=script&lang=js&"
export * from "./TabTemperature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6111b8d1",
  null
  
)

export default component.exports